import { useMemo } from 'react';
import { Card, CardBody, CardHeader, Col, Row } from 'reactstrap';
import { IoBarChartOutline } from 'react-icons/io5';
import LoadSpinner from '../Shared/ComponentLoading';

const currencyOptions = { style: 'currency', currency: 'GBP' };

const DashboardInvestments = ({ data, loading }) => {
    const totals = useMemo(() => {
        const orderedData = [
            ...data.filter((item) => item.fundName !== 'Cash'),
            ...data.filter((item) => item.fundName === 'Cash'),
        ];
        const totalFundValue = orderedData.reduce((total, item) => total + item.fundValue, 0);
        const totalProfitValue = orderedData.reduce((total, item) => total + item.profitValue, 0);
        const investmentTotal = orderedData.reduce((total, item) => total + item.investmentTotal, 0);

        return {
            data: orderedData,
            totalFundValue,
            totalProfitValue,
            investmentTotal,
            profitPercentage: (totalProfitValue / (totalFundValue - totalProfitValue) * 100).toFixed(1),
        };
    }, [data]);

    return (
        <Row>
            <Col xs="12">
                <Card className="mt-2">
                    <CardHeader className="cd-header">
                        <div className="d-flex">
                            <IoBarChartOutline size={24} style={{ color: '#111' }} />&nbsp;&nbsp;<div>Investments</div>
                        </div>
                    </CardHeader>
                    <CardBody>
                        {loading ? <LoadSpinner /> : (
                            <>
                                <Row className="pt-2 pb-2">
                                    <Col xs="4" className="investment-total text-start" style={{ overflow: 'ellipsis' }}>Fund Name</Col>
                                    <Col xs="0" sm="2" className="investment-total text-end hide-xs">Invested</Col>
                                    <Col xs="4" sm="2" className="investment-total text-end">Fund Value</Col>
                                    <Col xs="4" sm="2" className="investment-total text-end">Profit</Col>
                                    <Col xs="0" sm="2" className="investment-total text-end hide-xs">Profit %</Col>
                                </Row>

                                {totals.data.map((item, index) => (
                                    <div key={index} className="investment-item">
                                        <Row>
                                            <Col xs="4" className="investment-name ellipsis" style={{ overflow: 'hidden' }}>{item.fundName}</Col>
                                            <Col xs="0" sm="2" className="investment-value text-end hide-xs">
                                                {item.investmentTotal.toLocaleString('GB-en', currencyOptions)}
                                            </Col>
                                            <Col xs="4" sm="2" className="investment-value text-end">
                                                {item.fundValue.toLocaleString('GB-en', currencyOptions)}
                                            </Col>
                                            <Col xs="4" sm="2" className="investment-value text-end">
                                                {item.profitValue.toLocaleString('GB-en', currencyOptions)}
                                            </Col>
                                            <Col xs="0" sm="2" className="investment-value text-end hide-xs">
                                                {item.profitPercent.toFixed(1)}%
                                            </Col>
                                        </Row>
                                    </div>
                                ))}
                                <Row className="pt-2 pb-2">
                                    <Col xs="4" className="investment-name" />
                                    <Col xs="0" sm="2" className="investment-total text-end hide-xs">
                                        {totals.investmentTotal?.toLocaleString('GB-en', currencyOptions)}
                                    </Col>
                                    <Col xs="4" sm="2" className="investment-total text-end">
                                        {totals.totalFundValue?.toLocaleString('GB-en', currencyOptions)}
                                    </Col>
                                    <Col xs="4" sm="2" className="investment-total text-end">
                                        {totals.totalProfitValue?.toLocaleString('GB-en', currencyOptions)}
                                    </Col>
                                    <Col xs="0" sm="2" className="investment-total text-end hide-xs">{`${totals.profitPercentage}%`}</Col>
                                </Row>
                            </>
                        )}
                    </CardBody>
                </Card>
            </Col>
        </Row>
    );
};

export default DashboardInvestments;
